// extracted by mini-css-extract-plugin
module.exports = {"submit":"styles_submit__l2-Pr","submitting":"styles_submitting__3B8mi","loader":"styles_loader__OPWyD","spin":"styles_spin__35GN9"};